export default __webpack_public_path__ + "static/media/00.2420caf2.jpg";